import { Injectable } from '@angular/core';
import { CommonService } from '../common/common.service';
import { Provincia } from '../../domain/provincia.domain';

@Injectable({
  providedIn: 'root'
})
export class ProvinciaService extends CommonService<Provincia> {
  constructor() {
    super('provincias');
  }
}
